import { render, staticRenderFns } from "./evaluadorjs.vue?vue&type=template&id=5db7dc7c"
import script from "./evaluadorjs.vue?vue&type=script&lang=js"
export * from "./evaluadorjs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports